import React from "react";
import config from "../config";
import { RaisedButton } from "material-ui";
import qs from "qs";

import ItemTable from "./partials/item-table.jsx";
import BackButton from "./partials/back-button.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import ItemBucketActions from "../actions/ItemBucketActions";
import ItemBucketStore from "../stores/ItemBucketStore";
import ItemActions from "../actions/ItemActions";
import ItemStore from "../stores/ItemStore";
import UserStore from "../stores/UserStore";
import EventBucketStore from "../stores/EventBucketStore";

class ItemBucket extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isFetchingItemBucket: false,
      fetchedItemBucket: null
    };

    this._makeCsvLink = this._makeCsvLink.bind(this);
  }

  static getStores() {
    return [ItemBucketStore, ItemStore, UserStore];
  }

  static getPropsFromStores() {
    return {
      getItemBucketById: ItemBucketStore.getItemBucketById,
      getItemsForItemBucket: ItemStore.getItemsForItemBucket,
      apiKey: UserStore.getState().apiKey,
      getEventBucketById: EventBucketStore.getEventBucketById
    };
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  _makeCsvLink() {
    let query = {
      god_become_user: UserStore.isGod()
        ? UserStore.getGodCredentials().activeUser
        : undefined,
      api_key: this.props.apiKey
    };

    return `${config.endpoint}item_buckets/${
      this.props.params.itemBucketId
    }/items.csv?${qs.stringify(query)}`;
  }

  getStyles() {
    return {};
  }

  componentDidMount() {
    this.componentWillReceiveProps(this.props);
  }

  componentWillReceiveProps(newProps) {
    var itemBucket = newProps.getItemBucketById(newProps.params.itemBucketId);

    if (
      !this.state.isFetchingItemBucket &&
      this.state.fetchedItemBucket !== newProps.params.itemBucketId
    ) {
      ItemBucketActions.fetchOne(newProps.params.itemBucketId);
      ItemActions.fetchAllForItemBucket(newProps.params.itemBucketId);
      this.setState({ isFetchingItemBucket: true });
    } else if (itemBucket) {
      this.setState({
        isFetchingItemBucket: false,
        fetchedItemBucket: itemBucket.id
      });
    }
  }

  render() {
    var styles = this.getStyles(),
      itemBucket = this.props.getItemBucketById(this.props.params.itemBucketId),
      items = this.props.getItemsForItemBucket(this.props.params.itemBucketId);

    if (!itemBucket) {
      return null;
    }

    return (
      <div>
        <h1>{itemBucket.name}</h1>
        <div style={{ margin: "10px 0 20px" }}>
          <BackButton
            label={"item buckets"}
            style={{ marginRight: 7 }}
            arrowStyle={{
              display: "inline-block",
              transform: "scale(1.25) translateY(-1px)"
            }}
            onTouchTap={() =>
              this.props.location.state && this.props.location.state.fromListing
                ? this.context.router.goBack()
                : this.context.router.push(
                    `/event_buckets/${this.props.params.eventBucketId}/item_buckets`
                  )
            }
          />
          <RaisedButton
            style={{ marginRight: 7 }}
            label="Settings"
            onTouchTap={() =>
              this.context.router.push(
                `/event_buckets/${this.props.params.eventBucketId}/item_buckets/${this.props.params.itemBucketId}/edit`
              )
            }
          />
          <RaisedButton
            style={{ verticalAlign: "top" }}
            href={this._makeCsvLink()}
            target="_blank"
            label="Download (.csv)"
          />
        </div>
        <ItemTable
          items={items}
          eventBucket={this.props.params.eventBucketId}
          hideItemBucket={true}
          showPerson={true}
          location={this.props.location}
        />
      </div>
    );
  }
}

export default connectToStores(ItemBucket);



// WEBPACK FOOTER //
// ./src/app/components/item-bucket.jsx